import React, { useState, useEffect } from 'react';
import { Popover } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  Character,
  AbilityEffect,
  RollableTable,
  CharacterSheetInterface,
  BasicCreatureInstance,
  ComplexCreatureInstance,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import DataUtilities from '@dndUtilities/data_utilities';

import ButtonBox from "@components/input/buttons/ButtonBox";
import LoadingBox from "@components/input/LoadingBox";

import RollableTableRoller from "@dndComponents/other/RollableTableRoller";

interface Props {
  char: Character | BasicCreatureInstance | ComplexCreatureInstance;
  char_interface?: CharacterSheetInterface;
  effect: AbilityEffect;
  shared: boolean;
}

const api = API.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterRollableTableEffect({
  char,
  effect,
  shared
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState<HTMLSpanElement | null>(null);
  const [rollable_table, setRollableTable] = useState<RollableTable | null>(null);

   
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const load = async () => {
    if (char instanceof Character) {
      const obj_finder = data_util.rollable_tables.find(o => o._id === effect.rollable_table_id);
      if (obj_finder) {
        await api.loadObject(obj_finder);
        setRollableTable(obj_finder);
      }
    } else {
      setLoading(true);
      const res = await api.getSetOfObjects({ data_types: ["rollable_table"] });
      const tables = res.rollable_table as RollableTable[];
      
      const obj_finder = tables.find(o => o._id === effect.rollable_table_id);
      if (obj_finder) {
        await api.loadObject(obj_finder);
        setRollableTable(obj_finder);
      }
      setLoading(false);
    }
    setFetched(true);
  }

  const renderExtras = () => {
    return [
      <Popover key="rolls"
        open={ popoverAnchorEl !== null }
        anchorEl={popoverAnchorEl}
        onClose={() => {
          setPopoverAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        { renderRoll() }
      </Popover>
    ];
  }

  const renderRoll = () => {
    if (popoverAnchorEl !== null) {
      if (effect && rollable_table) {
        // debugger;
        return (
          <RollableTableRoller 
            name={effect.name}
            rollable_table={rollable_table}
          />
        );
      }
    }
    return null;
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else if (!rollable_table) {
    return <Grid>Error</Grid>;
  } else {
    // console.log(rollable_table);
    const enabled = shared || char instanceof BasicCreatureInstance || (api.user && (char.owner_id === api.user._id || (char instanceof Character && char.campaign !== null && char.campaign.owner_id === api.user._id)));
    return (
      <Grid className="centered" container spacing={0} direction="row">
        <Grid
          className="centered"
          size={{
            xs: 6
          }}>
          { effect.name === "" ? rollable_table.name : effect.name }
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            disabled={ !enabled }
            name={`1d${rollable_table.dice_size}`}
            onClick={(event: React.MouseEvent<HTMLSpanElement>) => {
              setPopoverAnchorEl(event.currentTarget);
            }}
          />
        </Grid>
        { renderExtras() }
      </Grid>
    );
  }
}
